<template>
  <b-card class="shadow" style="min-height: 700px" ref="printMe">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            {{ $t("Gráficos de Encaminhamentos") }}
          </h5>
          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button
              v-if="!viewFilterReport"
              variant="outline-dark"
              :class="range === 'weekly' ? 'active' : ''"
              @click="updateAnalytics('weekly')"
            >
              <i class="fas fa-calendar-week"></i>
              {{ $t("Weekly") }}
            </b-button>
            <b-button
              v-if="!viewFilterReport"
              variant="outline-dark"
              :class="range === 'monthly' ? 'active' : ''"
              @click="updateAnalytics('monthly')"
            >
              <i class="fas fa-calendar-alt"></i>
              {{ $t("Monthly") }}
            </b-button>
            <b-button
              v-if="!viewFilterReport"
              variant="outline-dark"
              :class="range === 'yearly' ? 'active' : ''"
              @click="updateAnalytics('yearly')"
            >
              <i class="fas fa-calendar"></i>
              {{ $t("Yearly") }}
            </b-button>
          </b-button-group>
        </div>
      </div>
      <filter-reports
        :report="report"
        @loadlist="getAnalytics"
        :showFilterReport="viewFilterReport"
        @hideFilter="viewFilters"
        :data_inicio="data_inicio"
        :data_fim="data_fim"
        @update:data_inicio="data_inicio = $event"
        @update:data_fim="data_fim = $event"
      ></filter-reports>

      <div class="col-12" id="boxPrint">
        <b-tabs content-class="mt-3">
          <b-tab
            title="Encaminhamentos Por Período"
            active
            @click.prevent="changeTab('Encaminhamentos Por Período')"
          >
            <div
              class="col-md-12"
              v-if="tabAtiva == 'Encaminhamentos Por Período'"
            >
              <area-graph
                :loading="loading"
                :data="report.lista_encaminhamentos"
                titulo="Encaminhamentos"
                tipo="encaminhamentos"
                :range="range"
                sizearea="300px"
                sizecard="375px"
              />
            </div>
            <div class="col-md-12">
              <p class="text-muted small pb-1 mb-1">
                Total de
                <b v-if="report.total_lista_encaminhamentos"
                  >({{ report.total_lista_encaminhamentos }})
                </b>
                {{ tabAtiva }}
              </p>
            </div>
          </b-tab>
          <b-tab
            title="Encaminhamentos Por Tipo"
            @click.prevent="changeTab('Encaminhamentos Por Tipo')"
          >
            <div class="row">
              <div
                class="col-md-12"
                v-if="tabAtiva == 'Encaminhamentos Por Tipo'"
              >
                <pie-chart
                  :data="report.tipos_encaminhamentos"
                  height="800px"
                ></pie-chart>
              </div>
            </div>
          </b-tab>

          <b-tab
            title="Encaminhamentos Por Unidades"
            @click.prevent="changeTab('Encaminhamentos Por Unidades')"
          >
            <div class="row">
              <div
                class="col-md-12"
                v-if="tabAtiva == 'Encaminhamentos Por Unidades'"
              >
                <pie-chart
                  :donut="true"
                  :data="report.unidades_encaminhamentos"
                  height="600px"
                ></pie-chart>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="col-md-12 text-center">
        <b-button
          :title="$t('Imprimir')"
          class="py-2"
          size="sm"
          type="button"
          v-b-tooltip.hover
          variant="primary"
          @click="printHtml()"
        >
          <i class="fas fa-print"></i>
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "EncaminhamentosGraficos",
  data() {
    return {
      loading: true,
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTecnicos: true,
      loadingSearchTipos: true,
      range: "yearly",
      report: {
        lista_encaminhamentos: [],
        total_lista_encaminhamentos: 0,
        percapita: [],
        corraca: [],
        usuarios: [],
        deficiencias: [],
        datas: {
          start: "",
          end: "",
        },
      },
      tabAtiva: "Encaminhamentos Por Período",
      filtros: {},
      chartData: [
        ["Jan", 4],
        ["Feb", 2],
        ["Mar", 10],
        ["Apr", 5],
        ["May", 3],
      ],
      data_inicio: "",
      data_fim: "",
    };
  },
  mounted() {
    this.getAnalytics();
  },

  methods: {
    changeTab(value) {
      if (value) {
        this.tabAtiva = value;
      } else {
        this.tabAtiva = "Encaminhamentos Por Período";
      }
      this.getAnalytics();
    },
    updateAnalytics(range) {
      if (this.range !== range) {
        this.range = range;
        this.getAnalytics();
      }
    },
    getAnalytics() {
      if (this.data_inicio) {
        this.filtros.data_inicial = this.$options.filters.formatDateYMD(
          this.data_inicio
        );
      }
      if (this.data_fim) {
        this.filtros.data_final = this.$options.filters.formatDateYMD(
          this.data_fim
        );
      }

      this.loading = true;
      const tab = { tab: this.tabAtiva };
      axios
        .get("api/dashboard/report/encaminhamentos/graficos", {
          params: {
            range: this.range,
            filtros: this.filtros,
            ...tab,
          },
        })
        .then((response) => {
          this.loading = false;
          this.report = response.data.data.reports;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

